module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="people-panel">\n	';
 _.each(items, function(element) { 
__p+='\n		';
 if ( element.type === "groupStart" ) { 
__p+='\n			\n			<div class="people-group">\n\n		';
 } else if ( element.type === "select" ) { 
__p+='\n\n			<select name="'+
((__t=( element.key ))==null?'':__t)+
'" class="'+
((__t=( element.class ))==null?'':__t)+
'">\n				';
 _.each(element.values, function(value) { 
__p+='\n				<option value="'+
((__t=( value[0] ))==null?'':__t)+
'" '+
((__t=( model.get(element.key) == value[0] ? 'selected' : '' ))==null?'':__t)+
'>'+
((__t=( value[1] ))==null?'':__t)+
'</option>\n				';
 }); 
__p+='\n			</select>\n\n		';
 } else if ( element.type === "groupEnd" ) { 
__p+='\n\n			</div>\n\n		';
 } else if ( element.type === "break" ) { 
__p+='\n\n			<br>\n\n		';
 }; /* end if element.type */ 
__p+='\n	';
 }); 
__p+='\n</div>\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/reserva-people-template.html
// module id = 59
// module chunks = 0